import {
    useState,
    useEffect,
    useCallback,
    ChangeEventHandler,
    KeyboardEventHandler,
} from 'react';
import { useStore } from '@ui/hooks/useStore';
import useKeyDown from '@ui/hooks/useKeyDown';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';
import { IState } from './IState';
import { GridSelectionModel, GridCallbackDetails } from '@mui/x-data-grid';

const useAddDeviceToGroup = (onClose: ICloseEvent['onClose']) => {
    const { groups, lang, devices, app } = useStore();
    const key = useKeyDown();
    const id = groups.selectedGroupId;
    const [group] = groups.groupsList.filter((g) => g.id === id);
    const groupName = group?.name;
    const initState: IState = {
        imeiDevices: [],
        groupName,
        groupNameError: false,
    };
    const [state, setState] = useState(initState);

    const checkGroupNameExist = (name: string) => {
        return groups.groupsList.some((group) => group.name === name);
    };
    const checkGroupNameMatches = (name: string, id: string | null) => {
        return (
            name !==
            groups.groupsList.filter((group) => group.id === id)[0].name
        );
    };
    const groupNameValidate = (name: string) => {
        if (
            !name ||
            (checkGroupNameExist(name) &&
                checkGroupNameMatches(name, groups.selectedGroupId))
        ) {
            setState((prev) => ({
                ...prev,
                groupNameError: true,
            }));
            return false;
        } else {
            setState((prev) => ({
                ...prev,
                groupNameError: false,
            }));
            return true;
        }
    };
    const handleInputClick = () => {
        groups.resetServerError();
        setState((prev) => ({
            ...prev,
            groupNameError: false,
        }));
    };
    ////ЗДЕСЬ МЕНЯТЬ
    const handleGroupNameChange: ChangeEventHandler<HTMLInputElement> = (e) => {
        handleInputClick();
        const groupId = e.target.value;
        setState((prev) => ({
            ...prev,
            groupId,
        }));
    };
    const handleSaveClick = useCallback(() => {
        const {
            imeiDevices
        } = state;
        if (!app.demoMode) {
            if (!!imeiDevices.length &&id) {
                imeiDevices.map((p) => {
                    devices.setEditedDeviceImei(p.toString());
                    groups.addDevice(id);
                    
                })
                devices.resetSelectedDeviceImei()
                devices.resetEditedDeviceImei()
            }
        } else if (app.demoMode) app.setDemoModeError();
    }, [handleInputClick, state]);
    const handleKey = (key: string) => {
        switch (key) {
            case 'Escape':
                onClose();
                break;
            case 'Enter':
                handleSaveClick();
                break;
        }
    };
    const handleKeyDown: KeyboardEventHandler<HTMLElement> = (e) => {
        const { key } = e;
        if (key === 'Enter') {
            e.stopPropagation();
            e.preventDefault();
            handleKey(key);
        }
    };
    const handleBtnKeyDown: KeyboardEventHandler<HTMLElement> = (e) => {
        const { key } = e;
        if (key === 'Enter') {
            e.stopPropagation();
            e.preventDefault();
            const target = e.target as HTMLElement;
            target.click();
        }
    };
    const handleCheckedDevice = (
        selectionModel: GridSelectionModel, 
        details: GridCallbackDetails<any>) => {
            setState((prev) => ({
                ...prev,
                imeiDevices: selectionModel,
            }));
      }
    const handlers = {
        handleGroupNameChange,
        handleSaveClick,
        handleInputClick,
        handleKeyDown,
        handleBtnKeyDown,
        handleCheckedDevice
    };

    useEffect(() => {
        handleInputClick();
        if (groups.operationSuccess) {
            groups.resetOperationSuccess();
        }
        setState((prev) => ({ ...prev, groupName }));
        const element = document.activeElement as HTMLElement;
        if (element) {
            element.blur();
        }
        return () => {
            handleInputClick();
        };
    }, []);
    useEffect(() => {
        if (groups.operationSuccess) {
            onClose();
            groups.resetOperationSuccess();
        }
    }, [groups.operationSuccess]);
    useEffect(() => {
        handleKey(key);
    }, [key]);
    useEffect(() => {
        if (!group && !groups.loading) onClose();
    }, [group, groups.loading]);

    return {
        store: groups,
        lang,
        state,
        handlers,
        devices
    };
};

export default useAddDeviceToGroup;
